<template>
  <div
    class="main"
    :style="{
      backgroundImage: 'url(' + this.$store.state.splashImgUrl + ')',
    }"
  >
    <div class="dim"></div>
    <div class="qr">
      <p class="small-line3">모바일앱 다운로드</p>
      <span class="qr-area">
        <vue-qrcode class="qr-img" :value="appStoreUrl" />
        <div class="log-small">
          <img class="log-apple" src="@/assets/logo-apple.png" />
          <span class="qr-name">iOS</span>
        </div>
      </span>
      <span class="qr-area">
        <vue-qrcode class="qr-img" :value="googlePlayStoreUrl" />
        <div class="log-small">
          <img class="log-android" src="@/assets/logo-android.png" />
          <span class="qr-name">android</span>
        </div>
      </span>
    </div>
    <div class="info-area">
      <img
        v-if="isGolfService"
        class="log-img"
        src="@/assets/golf/spotv-now-golf.png"
      />
      <img v-else class="log-img" src="@/assets/logo-spotvnow-s.png" />
      <div class="nor-line1">{{ loginMessage }}</div>
      <button
        class="button1"
        :class="{ focused: focusIndex == 0 }"
        @mouseover="focusIndex = 0"
        @click="enterKeyProc"
      >
        로그인
      </button>
      <button
        class="button2"
        :class="{ focused: focusIndex == 1 }"
        @mouseover="focusIndex = 1"
        @click="enterKeyProc"
      >
        회원가입
      </button>
      <div class="small-line2">{{ serviceMessage }}</div>
    </div>
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode";
import { isGolf } from "@/utils/common";

export default {
  components: {
    VueQrcode,
  },
  data() {
    return {
      isActiveVue: true,
      focusIndex: 0,
      isGolfService: isGolf,
    };
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
    appStoreUrl() {
      return process.env.VUE_APP_APP_STORE_URL;
    },
    googlePlayStoreUrl() {
      return process.env.VUE_APP_GOOGLE_PLAY_STORE_URL;
    },
    loginMessage() {
      return (process.env.VUE_APP_LOGIN_MESSAGE || "").replace(/\\n/g, "\n");
    },
    serviceMessage() {
      return (process.env.VUE_APP_SERVICE_MESSAGE || "").replace(/\\n/g, "\n");
    },
  },
  methods: {
    moveToQrLoginView() {
      this.$router.replace({
        name: "login-qr",
        params: {
          t: new Date().getTime(),
        },
      });
    },
    moveToSignUpQrView() {
      this.$router.replace({
        name: "signup",
        params: {
          t: new Date().getTime(),
        },
      });
    },
    enterKeyProc() {
      switch (this.focusIndex) {
        case 0:
          this.moveToQrLoginView();
          break;
        case 1:
          this.moveToSignUpQrView();
          break;
      }
    },
    leftKeyProc() {
      this.focusIndex = 0;
    },
    rightKeyProc() {
      this.focusIndex = 1;
    },
    backKeyProc() {
      this.$router.push({
        name: "exit",
        params: {
          t: new Date().getTime(),
        },
      });
    },
  },
  watch: {
    keyInput(val) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "Enter":
            this.enterKeyProc();
            break;
          case "ArrowLeft":
            this.leftKeyProc();
            break;
          case "ArrowRight":
            this.rightKeyProc();
            break;
          case "Backspace":
            this.backKeyProc();
            break;
        }
      }
    },
  },
  created() {
    this.$store.dispatch("FETCH_SPLASH");
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  background-size: contain;
  background-repeat: no-repeat;
}
.dim {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
  background-color: black;
  opacity: 0.3;
}
.info-area {
  position: absolute;
  left: 1043px;
  top: 367px;
}

.qr {
  position: absolute;
  left: 1468px;
  top: 54px;
  width: 392px;
}
.qr-area {
  position: relative;
}
.qr-img {
  position: relative;
  width: 156px;
  height: 156px;
  margin: 0 20px 0 20px;
}
.log-small {
  position: absolute;
  left: 0px;
  top: 34px;
  width: 196px;
}
.log-apple {
  position: relative;
  margin-left: 74px;
  margin-top: -3px;
  margin-right: 5px;
  width: 22px;
  height: 24px;
}

.log-android {
  position: relative;
  width: 24px;
  height: 14px;
  margin-left: 50px;
  margin-right: 4px;
}
.qr-name {
  position: relative;
  font-size: 22px;
  line-height: 24px;
  color: #c9c9c9;
}

.log-img {
  height: 46px;
}

.nor-line1 {
  margin: 24px 26px 32px 0;
  font-size: 32px;
  line-height: 1.5;
  color: #a0a0a0;
  white-space: pre-wrap;
}

button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  border: none;
  color: #eeeeee;
  margin-right: 24px;
}

button.focused {
  border: solid 4px #eeeeee;
}

.small-line1 {
  margin: 84px 9px 16px 0;
  font-size: 22px;
  line-height: 1.45;
  color: #707070;
}

.small-line2 {
  margin: 126px 78px 0 0;
  font-size: 22px;
  line-height: 34px;
  color: #707070;
  white-space: pre-wrap;
}

.small-line3 {
  margin-bottom: 16px;
  width: 392px;
  text-align: center;
  font-size: 22px;
  line-height: 1;
  color: #eeeeee;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .main {
    position: absolute;
    left: 0;
    top: 0;
    width: 1280px;
    height: 720px;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .dim {
    position: absolute;
    left: 0;
    top: 0;
    width: 1280px;
    height: 720px;
    background-color: black;
    opacity: 0.3;
  }
  .info-area {
    position: absolute;
    left: 820px;
    top: 251px;
  }

  .qr {
    position: absolute;
    left: 976px;
    top: 24px;
    width: 280px;
    height: 179px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 16px;
  }
  .qr-area {
    position: relative;
    display: inline-block;
    width: 104px;
    text-align: center;
    margin-left: 24px;
  }

  .qr-img {
    position: relative;
    width: 104px;
    height: 104px;
    margin: 0;
  }
  .log-small {
    position: relative;
    left: 0px;
    top: 0px;
    width: 104px;
  }
  .log-apple {
    position: relative;
    margin-right: 4px;
    margin-left: 0;
    width: 16px;
    height: 16px;
  }
  .log-android {
    position: relative;
    width: 16px;
    height: 9.3px;
    margin-left: 0px;
    margin-right: 4px;
  }
  .qr-name {
    position: relative;
    font-size: 14px;
    line-height: 24px;
    color: #c9c9c9;
  }

  .log-img {
    height: 32px;
  }

  .nor-line1 {
    margin: 18px 0px 40px 0;
    font-size: 20px;
    line-height: 1.5;
    color: #ffffff;
  }

  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    border: none;
    color: #ffffff;
    margin-right: 16px;
  }

  button.focused {
    border: solid 3px #ffffff;
  }

  .small-line1 {
    margin: 84px 9px 16px 0;
    font-size: 22px;
    line-height: 1.45;
    color: #707070;
  }

  .small-line2 {
    margin: 64px 0px 0 0;
    font-size: 14px;
    line-height: 14px;
    color: #eeeeee;
  }
  .signup-text {
    margin: 16px 0 8px 0;
  }

  .small-line3 {
    width: 100%;
    height: 16px;
    margin-top: 12px;
    margin-bottom: 9px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }
}
</style>
